const defaultPhoneNumbers = {
    "BF-XOF": "226123456789",
    "CM-XAF": "237123456789",
    "CI-XOF": "225123456789",
    "EG-EGP": "20123456789",
    "GH-GHS": "233123456789",
    "KE-KES": "254123456789",
    "MW-MWK": "265123456789",
    "ML-XOF": "223123456789",
    "NG-NGN": "234123456789",
    "RW-RWF": "250123456789",
    "SN-XOF": "221123456789",
    "TZ-TZS": "255123456789",
    "UG-UGX": "256123456789",
    "ZM-ZMK": "260123456789",
    "ZM-ZMW": "260123456789",
};

export default defaultPhoneNumbers;